import { Pipe, PipeTransform } from '@angular/core';
import {Util} from '../models/generico/util';

@Pipe({
  name: 'formatTime'
})
export class FormatTimePipe implements PipeTransform {

  transform(value: Date): string {
    return Util.formatTimeWithTwoDigits(value);
  }

}
